'use client';
import { useContext } from 'react';
import { RovingFocusContext } from './roving-focus-root.js';

// Logic from: https://www.joshuawootonn.com/react-roving-tabindex
// Inspired by: https://github.com/radix-ui/primitives/tree/main/packages/react/roving-focus/src
/**
@deprecated useRovingFocus is deprecated.
Handles props for `RovingFocus` in context with `RovingFocusRoot` */
const useRovingFocus = (value) => {
    const { elements, getOrderedItems, setFocusableValue, focusableValue, onShiftTab, orientation, } = useContext(RovingFocusContext);
    return {
        getOrderedItems,
        isFocusable: focusableValue === value,
        orientation,
        getRovingProps: (props) => ({
            ...props,
            ref: (element) => {
                if (element) {
                    elements.current.set(value, element);
                }
                else {
                    elements.current.delete(value);
                }
            },
            onKeyDown: (e) => {
                props?.onKeyDown?.(e);
                if (e.shiftKey && e.key === 'Tab') {
                    onShiftTab();
                    return;
                }
            },
            onFocus: (e) => {
                props?.onFocus?.(e);
                setFocusableValue(value);
            },
            'data-roving-tabindex-item': true,
            tabIndex: focusableValue === value ? 0 : -1,
        }),
    };
};

export { useRovingFocus };
